export const LOAD_CAMPUS_LIST = 'LOAD_CAMPUS_LIST';
export const SET_CAMPUS_LIST_LOADING_STATUS = 'SET_CAMPUS_LIST_LOADING_STATUS';
